import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  children?: React.ReactNode;
}

export function Input({ className = '', ...props }: InputProps) {
  return (
    <input
      className={`flex h-10 w-full rounded-md border border-[var(--brand-border)] bg-[var(--brand-surface-card)] px-3 py-2 text-sm text-[var(--brand-text-primary)] ring-offset-[var(--brand-surface-app)] file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-[var(--brand-text-muted)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand-focus-ring)] focus-visible:ring-offset-2 focus-visible:border-[var(--brand-accent-primary)] disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
      {...props}
    />
  );
} 
